angular.module('impactx.deliverycomplaint').component('ixSimpleComplaintItem', {
    bindings: {
        identifier: '<',
        item: '<',
        trns: '<',
        isDeleted: "<",
        deleteFunc: "&",
        recreateFunc: "&",
        selectedItem: "=",
        canRemove: "<",
        showComments: "=",
        syncItems: "&"
    },
    templateUrl: 'modules/deliverycomplaint/templates/simplecomplaint.item.tmpl.html',
    controller: "SimpleComplaintItemCtrl"
});